module.exports = __webpack_public_path__ + "static/media/29_CALCINHA_BICOLOR_ALCA_REGULAVEL_02.41b2b969.jpg";